import React from 'react';
import PropTypes from 'prop-types';

function RightStickBorder({ active, activeColor, color }) {
  return (
    <path
      d="M464.355 304.445C464.355 325.379 481.329 342.349 502.261 342.349C523.197 342.349 540.166 325.379 540.166 304.445C540.166 283.51 523.197 266.541 502.261 266.541C481.329 266.541 464.355 283.51 464.355 304.445Z"
      fill={active ? activeColor : color}
    />
  );
}

RightStickBorder.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

RightStickBorder.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  color: '#393E42',
};

export default RightStickBorder;
